module.exports = __webpack_public_path__ + "static/media/logo.ef7778f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 218
// module chunks = 0